export default {
      id: "color_capsula-usage",
      viewBox: "0 0 77 77",
      url: __webpack_public_path__ + "sprite.svg#color_capsula",
      toString: function () {
        return this.url;
      }
    }